import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { withPlugins, inview } from '@spon/plugins';

gsap.registerPlugin(ScrollTrigger);

function FadeIn({ plugins: { inview } }) {
	/*
	 *		Variables
	 */
	const els = document.querySelectorAll('[data-animate]');

	inview.settings = {
		root: null,
		rootMargin: '20px 0px 0px 0px',
		threshold: 0,
	};

	inview.observe([...els], {
		enter: ({ target }) => {
			if (!target.classList.contains('animate')) {
				setTimeout(() => {
					target.classList.add('animate'); // handled with CSS.
				}, 200);
			}
		},
	});
}
export default withPlugins(inview)(FadeIn);
